import React from "react";
import {Bar} from "react-chartjs-2";
import {BarElement, CategoryScale, Chart, Legend, LinearScale, Title, Tooltip} from "chart.js";
import './componentsCSS/QuestionnairesCounts.css';

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);


interface QuestionnaireChartProps {
    data: any;
}

const QuestionnaireChart: React.FC<QuestionnaireChartProps> = ({data}) => {
    const sortedEntries = Object.entries(data)
        .sort((a, b) => (b[1] as number) - (a[1] as number));

    const labels = sortedEntries.map(entry => entry[0]);
    const dataValues = sortedEntries.map(entry => entry[1]);


    const chartData = {
        labels: labels,
        datasets: [
            {
                label: "Participant Count",
                data: dataValues,
                backgroundColor: "rgba(54, 162, 235, 0.6)",
                borderColor: "rgba(54, 162, 235, 1)",
                borderWidth: 1,
            },
        ],
    };

    const chartOptions = {
        indexAxis: "y" as const,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {display: false},
            tooltip: {enabled: true},
        },
        scales: {
            x: {beginAtZero: true},
            y: {ticks: {autoSkip: false}},
        },
    };

    return (
        <div className="questionnaire-container">
            <div className="questionnaire-title">Questionnaires Counts</div>
            <div className="questionnaire-bar-chart">
                <Bar data={chartData} options={chartOptions}/>
            </div>
        </div>
    );
};

export default QuestionnaireChart;